import { getCountryList } from '@/api/s3Config';
import { ICountryItem } from '@reolink-cloud/interface';

/**
 * 国家信息管理器，获取s3的json文件并转换为表形式
 * @link https://countrycode.org/
 */
class CountriesManager {

    private countriesList: ICountryItem[] = [];

    /** 国家信息表，key为小写的ISO Code */
    private countryMap: Record<string, ICountryItem> = {};

    /** 初始化/更新 数据 */
    public async update(): Promise<void> {

        const timeStamp = process.env.TIME_STAMP!;
        this.countriesList = await getCountryList();

        for ( const country of this.countriesList ) {

            this.countryMap[country.code] = {
                code: country.code,
                name: country.name,
                text: country.name,
                image: `https://a.camovue-static.com/public/carrier/${country.name.toLowerCase().split( ' ' ).join( '_' )}.png?sv=${timeStamp}`
            };

        }

    }

    public getSingleCountryInfo( countryCode: string ): ICountryItem {

        return this.countryMap[countryCode] ?? {
            name: 'unknown',
            code: 'unknown',
            text: 'unknown',
            image: ''
        };

    }

    /**
     * 获取对应国家的信息
     * @param countryCodes 所需国家的二字编码数组
     * @returns 对应信息数组
     */
    public getCountryInfoList( countryCodes: string[] ): ICountryItem[] {

        const result: ICountryItem[] = [];
        for ( const countryCode of countryCodes ) {

            result.push( this.getSingleCountryInfo( countryCode ));

        }
        return result;

    }

}

export const countriesManager = new CountriesManager();
